require("./js/index");
require("./less/bootstrap/core/layout.less");
require("./less/bootstrap/font-awesome/layout.less");
require("./less/adminlte-debug.less");
require("leaflet_css");
require("./css/index.css");



/*****************
 ** WEBPACK FOOTER
 ** ./src/app.js
 ** module id = 0
 ** module chunks = 0
 **/